import { IconWarning } from '@americanexpress/dls-icons';
import { FxDisplayCardContainer } from '../FxContainers';

export const defaultContainer = {
  component: FxDisplayCardContainer,
  className: 'dls-gray-01-bg',
};

export const defaultTooltipMetaData = {
  // indicate if exception message can be displayed with the header
  mandatory: true,
  // exception message to display for missing info
  mandatoryMsg: 'Missing information',
  // custom validation and message function. If it returns a string, it will be displayed as an exception message
  excMsgFunc: null,
  // icon to display for exception message
  icon: IconWarning,
  type: 'warning',
  placement: 'right',
};

export const defaultHeadingProps = {
  level: 5,
  headingStyle: 'heading2',
};
